import { assetBaseUrl } from "@api";

const Logo = ({ className, brand, type = "center", height, width }) => {
  // Style options
  // left
  // center
  // leftinverted

  if (!brand) {
    brand = "ontik";
  }

  // Ontik-leftlight
  const imageName = `${brand.toLowerCase()}-${type}.png`;

  const url = assetBaseUrl() + imageName;

  return (
    <img
      style={{
        maxHeight: height ?? "100%",
        maxWidth: width ?? "100%",
        alignSelf: "center",
        height: "100%",
        width: "100%",
        objectFit: "contain",
      }}
      src={url}
      alt="logo"
    />
  );
};

export default Logo;
